import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";

import swal from "sweetalert2/dist/sweetalert2.all.min.js";

export default () => {
  Vue.use(VueSweetalert2);

  Vue.prototype.$swal = Vue.swal;
};
